import { ActionTypes } from '../actions';

const defaultState = {
    inTraffic: false,
    isInitialized: false,
    selectedLanguage: "en",
};


export default (state = defaultState, action) => {
    try {

        switch(action.type) {

            case ActionTypes.INITIALIZE_APP:
                return {
                    ...state,
                    inTraffic: true
                };

            case ActionTypes.HANDLE_LANGUAGE_CHANGE:
                return {
                    ...state,
                    selectedLanguage: action.payload
                };

            case ActionTypes.DONE_SIGNOUT:
                return {
                    ...defaultState
                };

            default:
                return state;

        }

    } catch(error) {
        console.error(`Error in appState reducer: ${ error.message || error.code || error }`, error);
    }

};
